import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { HashLoader } from "react-spinners";
import github from "../../Assets/Image/square-github.svg";
import linkedin from "../../Assets/Image/linkedin.svg";
import facebook from "../../Assets/Image/square-facebook.svg";
import discord from "../../Assets/Image/discord.svg";
import styles from "./Home.module.css";
import "animate.css";
import Typewriter from "typewriter-effect";
import { getInfo } from "../../Firebase/FirebaseFetch";
function Home(props) {
  const [info, setInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    await setIsLoading(true);
    getInfo().then((res) => {
      setInfo(res);
    });
    setIsLoading(false);
  };
  return (
    // <div id="home" style={{ height: "50vh", width: "50vw", background: "red", opacity: 0.5, pointerEvents: "none", zIndex: 99, position: "relative" }}></div>
    <Container id="home" className={styles.homeContainer}>
      <Row className="d-flex">
        {isLoading ? (
          <HashLoader color="#ffffff" />
        ) : (
          <>
            <Col
              lg={6}
              md={6}
              sm={12}
              className={[
                styles.profileImage,
                "animate__animated animate__fadeInDown",
              ]}
            >
              <img
                className="img-fluid"
                src={info.profile}
                alt="Profile_Image"
              />
            </Col>
            <Col
              lg={6}
              md={6}
              sm={12}
              className={[styles.heading, "animate__animated animate__flipInX"]}
            >
              <div className={styles.title}>
                <p className="m-0">
                  Hello, I'm{" "}
                  <span className={styles.important}>{info.name}</span>.
                </p>
                <span className="m-0 d-flex">
                  I'm a&nbsp;{"  "}
                  {
                    <Typewriter
                      options={{
                        strings: [info.title],
                        autoStart: true,
                        loop: true,
                      }}
                    />
                  }
                </span>
              </div>
            </Col>
          </>
        )}
      </Row>
      <div className={styles.socialIcons}>
        <a
          className={styles.socialIcon}
          href="https://github.com/arrafi-mahin"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.icon} src={github} alt="Github" />
        </a>
        <a
          className={styles.socialIcon}
          href="https://discordapp.com/users/arrafi.mahin#8409"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.icon} src={discord} alt="Facebook" />
        </a>
        <a
          className={styles.socialIcon}
          href="https://www.linkedin.com/in/arrafi-mahin/"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.icon} src={linkedin} alt="LinkedIn" />
        </a>
        <a
          className={styles.socialIcon}
          href="https://www.facebook.com/arrafi/"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.icon} src={facebook} alt="Facebook" />
        </a>
      </div>
    </Container>
  );
}

export default Home;
